exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement-icon[data-v-7c11f360] {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  color: white;\n  background: #6086b7;\n  display: inline-block;\n  cursor: pointer;\n  position: relative;\n  bottom: 2px;\n  font-size: 9px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 15px;\n}\n.agreement-tooltip[data-v-7c11f360] {\n  color: #6086b7;\n  font-size: 13px;\n}", ""]);

// exports
